enum TaskShadowIdAssignType {
    ASSIGN = 'assign',
    REASSIGN = 'reassign',
}

export default TaskShadowIdAssignType;
